import React from 'react';
import { ShieldIcon, LockIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ABOUT, HOME, PRACTICE } from '../content/site';
import { PageHeader } from '../components/blocks/PageHeader';
import { Section, Eyebrow, Reveal, ButtonLink } from '../components/ui/Primitives';
const CRED_ICONS: Record<string, React.ElementType> = {
  shield: ShieldIcon,
  lock: LockIcon
};
export function About() {
  const {
    language
  } = useLanguage();
  const t = ABOUT[language];
  const home = HOME[language];
  return <>
      <PageHeader eyebrow={t.eyebrow} title={t.headline} data-id="element-200" data-mp="3751eaalh1bic" />

      <Section tone="cream" data-id="element-201" data-mp="2s9bnlz5cca7a">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-20" data-id="element-202" data-mp="2sc7n3rwu76xu">
          <div className="lg:col-span-7" data-id="element-203" data-mp="2x86dtm5n111f">
            <Reveal data-id="element-204" data-mp="2xb10lkc4ixy0">
              <p className="font-serif text-xl font-light leading-relaxed text-espresso/85 lg:text-2xl" data-id="element-205" data-mp="1gv7tmsyr6m28">
                {home.aboutTeaser.lead}
              </p>
              <p className="mt-8 text-base font-light leading-relaxed text-espresso/65" data-id="element-206" data-mp="1lvcbambedmu1">
                {t.body}
              </p>
            </Reveal>

            <Reveal delay={0.12} data-id="element-207" data-mp="1pjgvitml6ku6">
              <dl className="mt-12 grid gap-8 border-t border-espresso/10 pt-10 sm:grid-cols-2" data-id="element-208" data-mp="1pk9wtf2s0i4x">
                {home.trustStrip.map(item => <div key={item.label} data-id="element-209" data-mp="1yjn7gb2mzcr8">
                    <dt className="font-serif text-lg font-light text-espresso" data-id="element-210" data-mp="1yhtwwkowk8dy">
                      {item.label}
                    </dt>
                    <dd className="mt-1.5 text-sm font-light text-espresso/55" data-id="element-211" data-mp="28hkq8j1q8hcg">
                      {item.detail}
                    </dd>
                  </div>)}
              </dl>
            </Reveal>
          </div>

          <div className="lg:col-span-5" data-id="element-212" data-mp="2i8ff7v6cxv1l">
            <Reveal delay={0.1} data-id="element-213" data-mp="2i9h1ywwqk5z5">
              <div className="relative" data-id="element-214" data-mp="2w6m5ap52eqqp">
                <div aria-hidden="true" className="absolute -left-4 -top-4 h-full w-full rounded-[1.75rem] border border-bronze/25" data-id="element-215" data-mp="2w7nfysi65b7w" />
                <img src={PRACTICE.heroImage} alt={home.hero.imageCaption} className="relative w-full rounded-[1.75rem] object-cover" data-id="element-216" data-mp="1ovxunxvnt0et" />
              </div>
            </Reveal>

            <div className="mt-8 space-y-5" data-id="element-217" data-mp="1xthwb7xfoypy">
              {t.credentials.map((cred, index) => {
              const Icon = CRED_ICONS[cred.icon] || ShieldIcon;
              return <Reveal key={cred.title} delay={0.15 + index * 0.1} data-id="element-218" data-mp="27ngwi1dy68f9" data-mpi={index}>
                    <div className="flex items-start gap-5 rounded-2xl border border-espresso/10 bg-white p-7" data-id="element-219" data-mp="2cint6p8sucuo">
                      <div className="mt-1 shrink-0 text-bronze" data-id="element-220" data-mp="2gmlrixqavjmo">
                        <Icon className="h-5 w-5" strokeWidth={1.25} data-id="element-221" data-mp="2ljufjey4qhvu" />
                      </div>
                      <div data-id="element-222" data-mp="m8umkbix1nxk">
                        <h2 className="font-serif text-lg font-normal text-espresso" data-id="element-223" data-mp="m9m6uq72bz8j">
                          {cred.title}
                        </h2>
                        <p className="mt-2 text-sm font-light leading-relaxed text-espresso/60" data-id="element-224" data-mp="jnv6soghkhs0">
                          {cred.description}
                        </p>
                      </div>
                    </div>
                  </Reveal>;
            })}
            </div>
          </div>
        </div>
      </Section>

      <Section tone="espresso" data-id="element-225" data-mp="50a7z6qn94pw">
        <Reveal data-id="element-226" data-mp="12m7iohys85ra">
          <div className="mx-auto max-w-3xl text-center" data-id="element-227" data-mp="12mr26342z27f">
            <div className="flex justify-center" data-id="element-228" data-mp="12k4ve5p0kqq9">
              <Eyebrow tone="light" data-id="element-229" data-mp="xmuzq8b17itz">{t.statementTitle}</Eyebrow>
            </div>
            <p className="mt-8 text-base font-light leading-relaxed text-pearl/75 lg:text-lg" data-id="element-230" data-mp="snrvgq2vlgn2">
              {t.statement}
            </p>
            <div className="mt-10 flex justify-center" data-id="element-231" data-mp="oloi1vwnc1z5">
              <ButtonLink to="/contact" variant="light" data-id="element-232" data-mp="3de0rghlenmsq">
                {home.contactTeaser.cta}
              </ButtonLink>
            </div>
          </div>
        </Reveal>
      </Section>
    </>;
}